import { useAuth0 } from '@auth0/auth0-react'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import { Box, Button, Stack, Typography, useMediaQuery } from '@mui/material'
import Cookies from 'js-cookie'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router'

import welcomeGif from '@/assets/images/Web signup welcome.gif'
import { persistor } from '@/store'
import { apiService, useLazyClearSessionQuery } from '@/store/apiService'
import { resetHeaders } from '@/utils/httpService'

const Redirect = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { isAuthenticated, getIdTokenClaims, logout } = useAuth0()
  const [clearSession] = useLazyClearSessionQuery()

  const mobile = useMediaQuery('(max-width:600px)')

  useEffect(() => {
    if (isAuthenticated) {
      getIdTokenClaims().then((response) => {
        if (response) {
          localStorage.setItem('auth', response.__raw)
        }
      })
    }
  }, [])

  useEffect(() => {
    if (!mobile) {
      navigate('/')
    }
  }, [mobile])

  const userAgent = navigator?.userAgent || navigator?.vendor || window?.opera
  const isIOSDevice = /iPad|iPhone|iPod/.test(userAgent)

  const redirectToiOSApp = () => {
    window.location.href = 'matisse://payment-success/launching-native-app'
  }

  const logoutWithRedirect = async () => {
    try {
      await clearSession('logout')

      dispatch(apiService.util.resetApiState())

      await persistor.purge()

      const cookies = Cookies.get()
      Object.keys(cookies).forEach((cookieName) => {
        Cookies.remove(cookieName)
      })

      window.localStorage.clear()
      window.sessionStorage.clear()

      resetHeaders()

      logout({
        logoutParams: { returnTo: window.location.origin },
      })
    } catch (error) {
      console.error('Error during logout:', error)
    }
  }

  return (
    <Box
      height="80vh"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      position="relative"
      px={4}
    >
      <Box textAlign="center" mb={4}>
        <Box
          component="img"
          src={welcomeGif}
          alt="Welcome"
          height={140}
          width={175}
          mb={-2}
        />
        <Typography
          variant="body1"
          fontFamily="Noto_Sans, sans-serif"
          fontSize="16px"
          mb={0.5}
        >
          You're all set!
        </Typography>
        <Typography
          variant="body2"
          fontFamily="Noto_Sans, sans-serif"
          fontSize="16px"
        >
          Take your workflow anywhere with our mobile app—fast, seamless, and
          built for on-the-go convenience.
        </Typography>
      </Box>

      <Stack direction="row" spacing={4} mt={4}>
        <Button
          onClick={async () => logoutWithRedirect()}
          variant="outlined"
          size="large"
          startIcon={<ChevronLeftIcon />}
          sx={{
            color: '#90CAF9',
            borderColor: '#90CAF9',
            fontWeight: 500,
            fontSize: '15px',
            width: '160px',
            letterSpacing: '0.46px',
            '&:hover': {
              borderColor: '#90CAF9',
            },
          }}
        >
          Logout
        </Button>

        <Button
          variant="contained"
          size="large"
          endIcon={<ChevronRightIcon />}
          onClick={redirectToiOSApp}
          disabled={!isIOSDevice}
          sx={{
            backgroundColor: '#90CAF9',
            color: 'black',
            fontWeight: 500,
            fontSize: '15px',
            width: '160px',
            letterSpacing: '0.46px',
            '&:hover': {
              backgroundColor: '#90CAF9',
            },
            '&.Mui-disabled': {
              backgroundColor: 'gray',
              color: 'white',
              opacity: 0.5,
            },
          }}
        >
          Go To App
        </Button>
      </Stack>
    </Box>
  )
}

export default Redirect
